import style from "./ConsultationLayout.module.css";

export const Section = ({ title, children }) => (
  <div className={style.section}>
    <p className={style.sectionTitle}>{title}</p>
    <div className={style.grid}>{children}</div>
  </div>
);
